import request from '@/utils/request'
import { getCommunityId } from '@/api/community/communityApi'

// 统计工单数量
export function countOrderNum(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/app/pms.countOrderNum',
      method: 'get',
      params: {
        ...params,
        communityId: getCommunityId()
      }
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        resolve(res)
      } else {
        reject(new Error(res.msg || '获取统计数据失败'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}
